import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    padding: ${theme.v3.spacing.xxs};
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.v3.spacing.xxs};
    border-radius: ${theme.v3.border.radius.md};
    background: ${theme.v3.colors.neutral[100]};
    margin: 24px 0 24px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      max-width: 100%;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: #363636;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-style: normal;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const Link = styled.a`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[50]};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: ${theme.v3.spacing.quarck};
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  `}
`;

export const StepsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    gap: ${theme.v3.spacing.xxxs};  

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      flex-direction: column;
      gap: ${theme.v3.spacing.sm};
    }
  `}
`;

export const StepCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${theme.v3.spacing.nano};
    flex: 1;
  `}
`;

export const StepContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.quarck};
    flex: 1;
  `}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: ${theme.v3.border.radius.circular};
    background: #E7F3FD;
  `}
`;

export const StepLabel = styled.span`
  ${({ theme }) => css`
    color: #707070;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `}
`;

export const StepTitle = styled.h3`
  ${({ theme }) => css`
    color: #363636;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const StepDescription = styled.p`
  ${({ theme }) => css`
    color: #4A4A4A;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;
